import React from 'react'
import { SvgIcon } from './SvgIcon'

interface Props {
  className?: string
}

export function RightArrow({ className }: Props) {
  return (
    <SvgIcon
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
      strokeLinecap="round"
    >
      <path d="M 14 8 L 8 13 M 14 8 L 8 3 M 2 8 L 14 8" />
    </SvgIcon>
  )
}
